// PaginationControls.js
// Shared Prev/Next pagination bar used across list pages, so pagination UI
// doesn't get hand-rolled per page. Renders nothing when there's only one
// page — nothing to page through.

import React from 'react';
import { Button } from 'react-bootstrap';

function PaginationControls({ page, totalPages, onPageChange, totalRows }) {
  if (!totalPages || totalPages <= 1) return null;

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <Button
        size="sm"
        variant="outline-primary"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        Previous
      </Button>
      <span>
        Page {page} of {totalPages}
        {typeof totalRows === 'number' ? ` (${totalRows} total)` : ''}
      </span>
      <Button
        size="sm"
        variant="outline-primary"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        Next
      </Button>
    </div>
  );
}

export default PaginationControls;
